import React, { useState } from "react";
import { Form, Input, Button, message } from "antd";
import { makePostCall, getUserDetails, clearAuthData } from "../../utils/helper";

const ChangePassword = ({ onCancel }) => {
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();

  const handleChangePassword = async (values) => {
    const { newPassword, confirmPassword } = values;

    if (newPassword !== confirmPassword) {
      message.error("Passwords do not match!");
      return;
    }

    setLoading(true);
    try {
      const userDetails = getUserDetails();
      const response = await makePostCall('/change-password', {
        user_id: userDetails?.user_id,
        username: userDetails?.username,
        new_password: newPassword.toUpperCase()
      });

      if (response.data?.success) {
        message.success("Password changed successfully! You will be logged out.");
        onCancel();
        // Logout and redirect to login page
        // Clears only auth state, not UI preferences (column configs, filters, etc.)
        clearAuthData();
        setTimeout(() => {
          localStorage.clear();
          window.location.replace("/login");
        }, 1500);
      } else {
        message.error(response.data?.message || "Failed to change password");
      }
    } catch (error) {
      console.error("Error changing password:", error);
      message.error("Failed to change password. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', minHeight: '30vh' }}>
      <Form
        form={form}
        layout="vertical"
        onFinish={handleChangePassword}
        autoComplete="off"
        style={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}
      >
        <div style={{ paddingTop: '20px' }}>
          <Form.Item
            label="New Password"
            name="newPassword"
            rules={[
              { required: true, message: "Please enter your new password" },
              { min: 4, message: "Password must be at least 4 characters long" }
            ]}
            style={{ marginBottom: '24px' }}
          >
            <Input.Password placeholder="Enter new password" />
          </Form.Item>

          <Form.Item
            label="Confirm New Password"
            name="confirmPassword"
            rules={[
              { required: true, message: "Please confirm your new password" }
            ]}
            style={{ marginBottom: '20px' }}
          >
            <Input.Password placeholder="Confirm new password" />
          </Form.Item>
        </div>

        <Form.Item style={{ marginBottom: 0, textAlign: "right" }}>
          <Button onClick={onCancel} style={{ marginRight: 8 }}>
            Cancel
          </Button>
          <Button type="primary" htmlType="submit" loading={loading}>
            Change Password
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default ChangePassword;
